import { useTheme } from "next-themes"
import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "#FFFFFF",
          "--normal-text": "#000000",
          "--normal-border": "var(--border)",
          "--success-bg": "#FFFFFF",
          "--success-text": "#000000",
          "--success-border": "var(--border)",
          "--error-bg": "#FFFFFF",
          "--error-text": "#000000",
          "--error-border": "var(--border)",
          "--warning-bg": "#FFFFFF",
          "--warning-text": "#000000",
          "--warning-border": "var(--border)",
          "--info-bg": "#FFFFFF",
          "--info-text": "#000000",
          "--info-border": "var(--border)",
          "--toast-text": "#000000",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
